// Parámetros previsionales chilenos — fuente única para la liquidación de sueldos.
// Se editan UNA vez al año (o cuando cambian los topes/IMM). Valores 2026.
// Cualquier constante previsional (IMM, topes imponibles, tope gratificación) vive acá,
// NO hardcodeada en el cálculo (src/utils/empleados.js).

export const PREVISIONAL_CHILE_2026 = {
  imm: 539000, // ingreso mínimo mensual
  topeGratificacionMensual: 219115, // tope grat mensual (según liquidación del contador)
  topeImponibleUF: 90, // tope imponible AFP y salud
  topeImponibleCesantiaUF: 135.2, // tope imponible seguro de cesantía
  cargaPatronalPct: 0.052, // carga del EMPLEADOR (SIS + cesantía patronal + mutual aprox);
  // se paga por PreviRed, NO se descuenta al empleado. Dato solo para proyección de PreviRed.
};
